import React from 'react'

export const phoneIconGreenBorderless = <svg xmlns="http://www.w3.org/2000/svg" viewBox="4226.999 4347 16 16">
 <defs></defs>
<path id="Path_2571" data-name="Path 2571" className="cls-1" d="M261.9,14.1a13.459,13.459,0,0,0,5.9,5.9l2-2a.959.959,0,0,1,.9-.2,11.27,11.27,0,0,0,3.2.5.9.9,0,0,1,.9.9v3.1a.9.9,0,0,1-.9.9A15.151,15.151,0,0,1,258.8,8.1a.9.9,0,0,1,.9-.9h3.1a.9.9,0,0,1,.9.9,11.27,11.27,0,0,0,.5,3.2.959.959,0,0,1-.2.9Z" transform="translate(3968.199 4339.8)"/>
</svg>

export const alertSVG = <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xlinkHref="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 20 17.3" enableBackground="new 0 0 20 17.3" xmlSpace="preserve">
<path id="Path_2100" className="st0" d="M0,17.3h20L10,0L0,17.3z M10.9,14.5H9.1v-1.8h1.8L10.9,14.5z M10.9,10.9H9.1V7.3h1.8L10.9,10.9z
	"/>
</svg>

export const exclamationMarkSVG = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26">
<path id="Path_2577" data-name="Path 2577" d="M13,0A13,13,0,1,0,26,13,13.038,13.038,0,0,0,13,0Zm1.3,19.5H11.7V11.7h2.6Zm0-10.4H11.7V6.5h2.6Z" />
</svg> 


// WEBPACK FOOTER //
// ./src/Images/AlertsSVG.js